import { takeLatest, put, call } from 'redux-saga/effects';
import { rejectInvitationStart } from './actions';
import { loading, success, failure } from './slice';
import { rejectInvitation } from './service';
import { Action } from '@reduxjs/toolkit';

function* rejectInvitationFlow(action: Action<unknown>) {
  if (rejectInvitationStart.match(action)) {
    try {
      yield put(loading());
      yield call(rejectInvitation, action.payload);
      yield put(success());
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export function* onRejectInvitationStart() {
  yield takeLatest(rejectInvitationStart, rejectInvitationFlow);
}
